import { Box, Text } from '@chakra-ui/react';
import { RiMailFill } from 'react-icons/ri';
import React from 'react';

const ContactEmail = ({email}) => {
  if(!email) {
    return null;
  }
  return (
    <Box className='linkWrapper' >
      <Text className='linkText' ><RiMailFill />  </Text><Text >{email}</Text></Box>
  );
}
export default ContactEmail;